import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import Msrp from "Shared/Msrp/index";
import styled from "styled-components";
import VinNumber from "src/components/VinNumber/VinNumber";
import "./DealVehicleInfo.scss";

export const ImageWrapper = styled("div")`
    max-width: 90px;
    width: 90px;
    display: flex;
    margin-top: auto;
    margin-bottom: auto;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        max-width: 134px;
        width: 134px;
    }
`;

const Img = styled("img")`
    border: 2px ${(props) => props.theme.palette.grey[40]} solid;
    font-family: "object-fit: cover;";
    height: auto;
    object-fit: cover;
    width: 100%;
`;

const VehicleTitle = styled("div")`
    /* stylelint-disable property-no-vendor-prefix  */
    -webkit-box-orient: vertical;
    /* stylelint-disable value-no-vendor-prefix  */
    -webkit-line-clamp: 3;
    line-height: 1em;
    text-transform: none;
    width: 230px;
    word-wrap: break-word;
`;

const VinNumberContainer = styled("div")`
    font-size: 12px;
    margin-top: 8px;
`;

export interface DealVehicleInfoProps {
    thumbnail: string;
    title: string;
    vin: string;
}

const DealVehicleInfo: React.FunctionComponent<DealVehicleInfoProps & WithTranslation> = ({
    thumbnail,
    title,
    vin,
}) => {
    return (
        <div className="DealVehicleInfo">
            <div className="DealVehicleInfo__vehicle-container">
                <ImageWrapper>
                    <Img src={thumbnail} />
                </ImageWrapper>
                <div className="DealVehicleInfo__text-wrapper">
                    <VehicleTitle data-e2e="vehicle-title">{title}</VehicleTitle>
                    <VinNumberContainer>
                        <VinNumber data-e2e="vehicle-vin">{vin}</VinNumber>
                    </VinNumberContainer>
                    <span className="DealVehicleInfo__text">
                        <Msrp vin={vin} />
                    </span>
                </div>
            </div>
        </div>
    );
};

export default withTranslation()(DealVehicleInfo);
